// authRoutes.js
import React from "react";
import { LoginPage as Login, loader as authLoader } from "../modules/Auth";

const authRoutes = [
  {
    path: "/",
    element: <Login />,
    // loader: authLoader,
  },
  {
    path: "/login",
    element: <Login />,
    // loader: authLoader,
  },
];

export default authRoutes;
